import { storage } from '@/plugins/firebase';
import { v4 as uuidv4 } from 'uuid';

const MAX_CHECK_RESIZED_IMAGE_COUNT = 100;

export async function uploadPhoto(storageFolderPath, photoFile) {
  if (!photoFile) return '';

  const storageFolderRef = storage.ref(storageFolderPath);
  const fileName = uuidv4(); // create random filename
  const resizedFileName = fileName + process.env.VUE_APP_RESIZED_IMAGE_SUFFIX;

  try {
    // upload original image
    const storageFileRef = storageFolderRef.child(fileName);
    await storageFileRef.put(photoFile);

    // get resize image
    return await getResizedImage(storageFolderRef, resizedFileName);
  } catch (err) {
    console.error(err);
    return '';
  }
}

export async function listFilesByPath(storagePath) {
  const storageRef = storage.ref(storagePath);
  return await storageRef.listAll();
}

export async function deletePhotoByFolderPath(folderPath) {
  const storageRef = storage.ref(folderPath);
  var fileListRef = await storageRef.listAll();
  fileListRef.items.forEach(async fileRef => {
    await fileRef.delete();
  });
}

// helper functions
async function getResizedImage(storageFolderRef, resizedFileName) {
  return new Promise((resolve, reject) => {
    // check resized image created or not
    let count = 0;
    const intervalId = setInterval(async () => {
      count += 1;
      if (count > MAX_CHECK_RESIZED_IMAGE_COUNT) {
        clearInterval(intervalId);
        reject('Maximum check exceeded.');
        return;
      }

      const all = await storageFolderRef.listAll();
      if (!resizedImageExist(all)) return;

      try {
        const storageResizedFileRef = storageFolderRef.child(resizedFileName);
        const resizedImageURL = await storageResizedFileRef.getDownloadURL();
        resolve(resizedImageURL);
        clearInterval(intervalId);
      } catch (e) {return;}
    }, 300);
  });
}

function resizedImageExist(listResult) {
  let exist = false;
  let suffixRegEx = new RegExp(process.env.VUE_APP_RESIZED_IMAGE_SUFFIX + '$');
  listResult.items.forEach(ref => {
    if (ref.name.match(suffixRegEx)) exist = true;
  });
  return exist;
}
